/* eslint-disable */
import Vote from 'views/Vote'

const VotePage = () => {
  return <Vote />
}

VotePage.Layout = VotePage
export default Vote
